import styled, { css } from 'styled-components';
import { Colors, toRem } from '.';

export type BadgeSize = 'xl' | 'lg' | 'md' | 'sm';

const toNumber = (size: BadgeSize) => {
    switch (size) {
        case 'xl': return 1;
        case 'lg': return 0.875;
        default:
        case 'md': return 0.75;
        case 'sm': return 0.625;
    }
};

export type BadgeProps = {
    padding?: string,
    round?: boolean,
    inline?: boolean,
    size?: BadgeSize,
    color?: string,
};

export const Badge = styled.div<BadgeProps>`
    display: ${p => p.inline ? 'inline-flex' : 'flex'};
    align-items: center;
    justify-content: center;
    padding: ${p => toRem(p.padding || '.125 .375')};
    ${p => p.color && `background: ${p.color}`};
    border-radius: 0.25rem;
    color: ${p => Colors.contrastTextColorFor(p.color || Colors.primary)};
    font-size: ${p => toRem(toNumber(p.size))};
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    text-align: center;
    text-decoration: none;

    ${p => p.round && css`
        border-radius: 999999px;
        padding: ${toRem(p.padding || '0')};
        width: ${toRem(.625 + (1 * toNumber(p.size)))};
        height: ${toRem(.625 + (1 * toNumber(p.size)))};
    `}
`;
